import { Mongo } from 'meteor/mongo';
import { DeclareMethod } from '/imports/methods';
import { Doc, ListMethodArg, ListMethodResponse, GetMethodResponse, ModelClass, References } from '/imports/types';

export interface LogActivity extends Doc {
  _id: string;
  runId: number;
  botId?: number;
  bot: string;
  entry: string;
  level: number;
  timestamp?: number;
}

type Model = LogActivity;
type Refs = References<Model>;

export const LogActivities = new Mongo.Collection<LogActivity>('logActivities');

export const listLogActivities = DeclareMethod<ListMethodArg<LogActivity>, ListMethodResponse<LogActivity, Refs>>('listLogActivities');
export const getLogActivity = DeclareMethod<string, GetMethodResponse<LogActivity, Refs>>('getLogActivity');
export const createLogActivity = DeclareMethod<Partial<LogActivity>, string>('createLogActivity');
export const updateLogActivity = DeclareMethod<Partial<LogActivity>, string>('updateLogActivity');
export const deleteLogActivity = DeclareMethod<string, undefined>('deleteLogActivity');

export const modelClass: ModelClass<Model, Refs> = {
  collection: LogActivities,
  editableFields: ['runId', 'botId', 'bot', 'entry', 'level', 'timestamp'],
  listMethod: listLogActivities,
  getMethod: getLogActivity,
  createMethod: createLogActivity,
  updateMethod: updateLogActivity,
  deleteMethod: deleteLogActivity,
  pathPrefix: '/log-activities',
  modelName: 'Log Activity',
  pluralName: 'Log Activities',
};
